<template>
  <div v-if="visible"
    class="form-group shipment-item card floating-label-container
           justify-content-center border-left-0 border-right-0 border-bottom-0 m-0"
    style="background-color: white; border-radius: 0;"
  >
    <div class="card-body p-3">
      <div class="form-row">
        <div class="col m-auto">
          <h5 class="card-title m-auto">
            <b-row>
              <b-col>
                <slot name="title"></slot>
              </b-col>
            </b-row>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerPrototypeItem',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      collapse: !this.expanded,
      removeConfirm: 0,
    };
  },
  methods: {
    remove(id) {
      this.removeConfirm += 1;
      if (this.removeConfirm === 2) {
        this.$emit('delete', id);
      }
    },
    resetRemoveConfirmation() {
      this.removeConfirm = 0;
    },
    toggleCollapse() {
      this.collapse = !this.collapse;
    },
    toggleHazardous() {
      this.$emit('toggleHazard');
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();
  },
};
</script>

<style scoped>
/*@import '../assets/styles/floatingLabel.scss';*/
.shipment-item-button {
  transition: all 200ms ease;
}

.shipment-item-button.text-dark:hover {
  color: #646464 !important;
}
</style>
